import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { utils } from 'gipsy-misc';

var propTypes = {
  text: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  ignoreOverflow: PropTypes.bool,
  hz: PropTypes.number,
  vt: PropTypes.number
};

var defaultProps = {
  vs: 50 /* vertical space */
  , hs: 50 /* horizontal space */
};

var Tooltip = function (_PureComponent) {
  _inherits(Tooltip, _PureComponent);

  function Tooltip(props) {
    var _this2 = this;

    _classCallCheck(this, Tooltip);

    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    _this.onResizeWindow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              utils.resolve.once('resize-window-' + _this.id, _this.avoidOverflow, 600);

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.avoidOverflow = function () {
      var _this$props = _this.props,
          position = _this$props.position,
          hs = _this$props.hs,
          ignoreOverflow = _this$props.ignoreOverflow;

      if (!_this.tooltip) {
        return;
      }
      var windowSize = utils.device.getWindowSize();
      var element = _this.tooltip.getBoundingClientRect();
      var parent = _this.tooltip.parentElement.getBoundingClientRect();

      var overflowLeft = !ignoreOverflow ? element.width + hs - (parent.left + parent.width) : 0;
      var overflowRight = !ignoreOverflow ? parent.left + element.width + hs - windowSize.width : 0;
      var awayFromBorder = 20;

      /* prevent tooltip to overflow the window */
      if (position.indexOf('left') !== -1 && overflowLeft > 0) {
        _this.setState({
          forceX: -(overflowLeft - hs + awayFromBorder)
        });
      } else if (position.indexOf('right') !== -1 && overflowRight > 0) {
        _this.setState({
          forceX: -(overflowRight - hs + awayFromBorder)
        });
      } else {
        _this.setState({
          forceX: 0
        });
      }
    };

    _this.id = utils.string.random();
    _this.state = {
      forceX: 0
    };
    return _this;
  }

  _createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.avoidOverflow();
      window.addEventListener('resize', this.onResizeWindow);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResizeWindow);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          text = _props.text,
          position = _props.position,
          vs = _props.vs,
          hs = _props.hs;
      var forceX = this.state.forceX;

      var style = {};

      if (position.indexOf('top') !== -1) {
        style.bottom = vs;
      } else {
        style.top = vs;
      }

      if (position.indexOf('left') !== -1) {
        style.right = forceX ? forceX : hs;
      } else {
        style.left = forceX ? forceX : hs;
      }

      return React.createElement(
        'div',
        { ref: function ref(_ref2) {
            return _this3.tooltip = _ref2;
          }, className: 'tooltip ' + (forceX === 0 ? position : ''), style: style },
        text
      );
    }
  }]);

  return Tooltip;
}(PureComponent);

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;

export default Tooltip;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/Tooltip/index.js
// module id = 821
// module chunks = 0